import * as React from 'react'

import { mbonusApi } from 'redux/services/mbonus'
import { GetMBonusParams, MBonusObject } from 'redux/services/mbonus/types'

import { AppLayoutTable } from 'components/AppLayoutTable'
import { AppLoader } from 'components/AppLoader'
import { AppPagination } from 'components/AppPagination'
import { AppTable } from 'components/AppTable'

import { MBONUS_STATUS_TEXT } from 'constants/mbonus'

import { formatDate } from 'shared/libs'
import { EmptyDetails } from 'shared/ui'

import { Details } from './components/Details'
import { Filters } from './components/Filters'
import { Statistics } from './components/Statistics'

export const MBonusPage = () => {
  const [selectedRowId, setSelectedRowId] = React.useState<
    MBonusObject['id'] | undefined
  >()
  const [filters, setFilters] = React.useState<GetMBonusParams>({
    limit: 10,
    offset: 0,
  })
  const [fetch, fetchState] = mbonusApi.useLazyGetMBonusQuery()

  React.useEffect(() => {
    fetch(filters)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  const onChangeFilters = (newFilters: GetMBonusParams) => {
    newFilters.limit = filters.limit
    newFilters.offset = filters.offset
    setFilters(newFilters)
  }

  return (
    <>
      <AppLayoutTable
        title="МБонус"
        header={<Filters onSubmit={onChangeFilters} />}
        statistics={<Statistics filters={filters} />}
        sidebarOpened={Boolean(selectedRowId)}
        sidebar={
          selectedRowId ? (
            <Details
              id={selectedRowId}
              onClose={() => setSelectedRowId(undefined)}
            />
          ) : (
            <EmptyDetails />
          )
        }
      >
        {fetchState.isLoading && <AppLoader />}
        {fetchState.data && fetchState.isSuccess && (
          <>
            <AppTable
              onClickRow={item => setSelectedRowId(item.id)}
              dataSource={fetchState.data.results}
              selected={{
                value: selectedRowId,
                key: 'id',
              }}
              headers={[
                {
                  data: 'ФИО сотрудника',
                  key: 'consultant_name',
                },
                {
                  data: 'Наименование организации',
                  key: 'name',
                },
                {
                  data: 'Количество ТТ',
                  key: 'count_points',
                },
                {
                  data: 'ID',
                  key: 'jira_key',
                },
                {
                  data: 'Статус',
                  key: 'status',
                  render: (_, item) => MBONUS_STATUS_TEXT[item.status],
                },
                {
                  data: 'Адрес',
                  key: 'get_full_address',
                },
                {
                  data: 'Дата создания',
                  key: 'created_at',
                  render: (_, item) => formatDate(item.created_at),
                },
                {
                  data: 'Размер кешбека',
                  key: 'cashback',
                },
                {
                  data: 'Категория клиента',
                  key: 'field_activity',
                  render: (_, item) => item.field_activity?.name,
                },
              ]}
            />

            <AppPagination
              forcePage={filters.offset! / filters.limit!}
              onPageChange={nextPage => {
                setFilters({
                  ...filters,
                  offset: (nextPage - 1) * filters.limit!,
                })
              }}
              count={fetchState.data.count / filters.limit!}
            />
          </>
        )}
      </AppLayoutTable>
    </>
  )
}
